export default __webpack_public_path__ + "static/media/webhook_url.87b789dc.png";